import "./GuessBosses.css";
import {
  Box,
  Grid,
  InputBase,
  Paper,
  Stack,
  Switch,
  Typography,
} from "@mui/material";

import dungeonsDataRaw from "../data/dungeons.json";
import { useEffect, useMemo, useState } from "react";
import slugify from "slugify";
import { SuccessImage } from "../components/SuccessImage";
import iconSword from "../res/red_sword_icon.png";

import iconFalse from "../res/icon_false.png";
import { Timer } from "../components/Timer";

const GRAY = "#42423f";
const GREEN = "rgba(180,211,10,0.7)";
const RED = "#bf4f51";

const slugifyOptions = {
  replacement: "-", // replace spaces with replacement character, defaults to `-`
  remove: undefined, // remove characters that match regex, defaults to `undefined`
  lower: true, // convert to lower case, defaults to `false`
  strict: true, // strip special characters except replacement, defaults to `false`
  locale: "vi", // language code of the locale to use
  trim: true, // trim leading and trailing replacement chars, defaults to `true`
};

export const GuessBosses = () => {
  const [input, setInput] = useState("");
  const [dungeonsFound, setDungeonsFound] = useState([]);
  const [cancelled, setCancelled] = useState(false);
  const [sortByLvl, setSortByLvl] = useState(false);

  const dungeonsData = useMemo(
    () =>
      dungeonsDataRaw.sort((a, b) => {
        if (sortByLvl && parseInt(a.lvl) < parseInt(b.lvl)) {
          return -1;
        } else if (sortByLvl && parseInt(a.lvl) > parseInt(b.lvl)) {
          return 1;
        } else {
          return a.boss.toLowerCase().localeCompare(b.boss.toLowerCase());
        }
      }),
    [sortByLvl]
  );

  const findBoss = (bossName) => {
    const bossFound = dungeonsData.find(
      ({ boss }) =>
        slugify(boss, slugifyOptions) === slugify(bossName, slugifyOptions)
    );
    return bossFound;
  };

  const handleInput = (value) => {
    setInput(value);
    const bossFound = findBoss(value);
    if (bossFound && !dungeonsFound.includes(bossFound)) {
      setDungeonsFound((current) => [...current, bossFound]);
      setInput("");
      const bossId = slugify(bossFound.boss, slugifyOptions);
      const element = document.getElementById(bossId);
      element.scrollIntoView({
        behavior: "auto",
        block: "center",
        inline: "center",
      });
    }
  };

  const gameEnded = cancelled || dungeonsFound.length === dungeonsData.length;

  // TIMER
  const [time, setTime] = useState(0);

  useEffect(() => {
    let interval = null;

    if (!gameEnded) {
      interval = setInterval(() => {
        setTime((time) => time + 1000);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => {
      clearInterval(interval);
    };
  }, [gameEnded]);
  const styles = (theme) => ({
    root: {
      backgroundColor: "blue",
      // Match [0, md)
      //       [0, 900px)
      [theme.breakpoints.down("md")]: {
        backgroundColor: "red",
      },
    },
  });
  return (
    <div>
      <div className="boss-input-wrapper">
        <InputBase
          autoFocus
          className="boss-input"
          inputProps={{
            style: {
              textAlign: "center",
              color: "white",
              fontSize: 23,
            },
          }}
          type="text"
          value={input}
          onChange={(event) => handleInput(event.target.value)}
          disabled={gameEnded}
        />
      </div>
      <div className="head-row">
        <Grid container>
          <Grid
            item
            xs={12}
            md={2}
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 0.5,
              alignItems: "center",
              paddingRight: 2,
            }}
          >
            <Switch
              checked={sortByLvl}
              color="success"
              onChange={() => setSortByLvl(!sortByLvl)}
            />
            <Typography color="white">
              Tri par lvl <Box component="img" src={iconSword} width="14px" />
            </Typography>
          </Grid>
          <Grid item className="success-ornament" xs={12} md={8}>
            <Typography fontSize={30} fontWeight="bold" color="#52290a">
              {dungeonsFound.length} / {dungeonsData.length}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={2}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              alignItems: "center",
              paddingRight: 2,
            }}
          >
            <Timer time={time} />
            <Box className="button-custom" onClick={() => setCancelled(true)}>
              <Box component="img" src={iconFalse} width="22px" />
              <span>Abandonner</span>
            </Box>
          </Grid>
        </Grid>
      </div>

      <Grid container spacing={"1px"} padding={0.5} paddingTop={"9em"}>
        {dungeonsData.map((dj, index) => (
          <Grid key={index} item xs={12} sm={6} md={6} lg={3}>
            <Paper
              elevation={0}
              id={slugify(dj.boss, slugifyOptions)}
              sx={{
                display: "flex",
                alignItems: "center",
                height: "5em",
                background: dungeonsFound.includes(dj)
                  ? GREEN
                  : cancelled
                  ? RED
                  : GRAY,
                color: "white",
                borderRadius: 0,
                opacity: 1,
                padding: 1.5,
                gap: 2,
              }}
            >
              <SuccessImage
                src={
                  dungeonsFound.includes(dj) || cancelled
                    ? `/dungeons/${slugify(dj.boss, slugifyOptions)}.png`
                    : null
                }
              />
              {(dungeonsFound.includes(dj) || cancelled) && (
                <Stack alignItems="flex-start">
                  <Typography fontSize={22} textAlign="left" lineHeight={1.2}>
                    {dj.boss}
                  </Typography>
                  <Typography fontSize={15} textAlign="left" lineHeight={1}>
                    {dj.dungeon}
                  </Typography>
                </Stack>
              )}
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
